import React from 'react';
import PropTypes from 'prop-types';

import MCategorieCardTranslated from '../molecules/_molecules.categorie-card-translated';

export default function OCategoriePreview({ items, className }) {
	return (
		<article className={`o-default-list o-large-list ${className}`}>
			{
				items.map((item) => {
					return (
						<MCategorieCardTranslated
							key={item.uuid}
							{...item}
						/>
					);
				})
			}
		</article>
	);
}

OCategoriePreview.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string,
};

OCategoriePreview.defaultProps = {
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.categorie-preview.js